import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.boundSync = this.sync.bind(this)
    this.boundOnFrameLoad = this.onFrameLoad.bind(this)
    document.addEventListener("turbo:load", this.boundSync)
    document.addEventListener("turbo:frame-load", this.boundOnFrameLoad)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundSync)
    document.removeEventListener("turbo:frame-load", this.boundOnFrameLoad)
  }

  onFrameLoad(event) {
    if (event.target.id === "owner-workspace") {
      this.sync()
    }
  }

  sync() {
    const pathname = window.location.pathname
    this.linkTargets.forEach((a) => a.classList.remove("is-active"))

    let best = null
    let bestLen = -1

    this.linkTargets.forEach((a) => {
      const href = a.getAttribute("href")
      if (!href) return

      let url
      try {
        url = new URL(href, window.location.origin)
      } catch {
        return
      }

      const linkPath = url.pathname
      const pathMatch = pathname === linkPath || pathname.startsWith(`${linkPath}/`)
      if (!pathMatch) return

      if (linkPath.length > bestLen) {
        bestLen = linkPath.length
        best = a
      }
    })

    if (best) best.classList.add("is-active")
  }
}
